import {Component, ViewEncapsulation} from '@angular/core';
import { OfferCardType } from "../../offer-card-data.model";
import { AbstractOfferCard } from '../abstract-offer-card.component';

@Component({
  selector: 'wow-offer-card',
  template: `
    <offer-card [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId" [positionIndex]="positionIndex"
                [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                [flow]="flow" [product]="product" [offerCardType]="offerCardType" [moduleReferer]="moduleReferer">
      <offer-multiple-image offer-image 
        [mediaKeys]="data.pictures_carrousel"
        [alt]="data.product_text + ' - '+ data.main_text"></offer-multiple-image>
      
      <ng-container offer-content>
        <offer-card-info [moduleId]="moduleId" [moduleIndex]="moduleIndex"
                         [positionIndex]="positionIndex"
                         [data]="data" [loyaltyMode]="loyaltyMode" [locale]="locale"
                         [flow]="flow" [offerCardType]="offerCardType"></offer-card-info>
      </ng-container>
    </offer-card>
  `,
  styleUrls: ['./wow-offer-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WowOfferCardComponent extends AbstractOfferCard {
  readonly offerCardType = OfferCardType.WOW;
}
